import React, { useState } from 'react';
import InsumoEditor from './InsumoEditor';
import { connect } from 'react-redux';
import {
  setPending,
  deleted,
  setDeletedPending,
  getAllDeleted,
  restore,
} from '../redux/actions/insumoActions';
import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  SelectOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import RestorePopup from './RestorePopup';
import MetaTable from './base/MetaTable';
import CustomCellRender from './base/CustomCellRender';

const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const InsumoList = ({
  location,
  stateData,
  proveedor,
  insumoTipo,
  dispatch,
}) => {
  const [showRestore, setShowRestore] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleRestore = () => {
    setShowRestore(true);
    getAllDeleted(dispatch);
  };

  const handleRestoreCancel = () => {
    setShowRestore(false);
    dispatch(setDeletedPending());
  };

  const handleRestoreOk = (data) => {
    dispatch(restore({ data: data }));
    setShowRestore(false);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const restoreColumns = [
    {
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'nombre',
    },
  ];

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
      ellipsis: true,
    },
    {
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'nombre',
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      search: true,
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Precio U$D',
      dataIndex: 'precio',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      ellipsis: true,
      title: 'Proveedor',
      dataIndex: 'proveedor',
      render: (text, record) => record.proveedor?.nombre,
      onFilter: (value, record) => {
        return record.proveedor_id === value;
      },
      sorter: (a, b) => a.proveedor?.nombre?.localeCompare(b.proveedor?.nombre),
      filterMultiple: true,
      filters: proveedor.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
    {
      width: 200,
      ellipsis: true,
      title: 'Tipo',
      dataIndex: 'tipo',
      render: (text, record) =>
        record.tipo?.nombre ||
        insumoTipo?.list?.data?.find((t) => t.id === record.tipo_id)?.nombre,
      onFilter: (value, record) => {
        return record.tipo_id === value;
      },
      sorter: (a, b) => {
        const nameA =
          a.tipo?.nombre ||
          insumoTipo?.list?.data?.find((t) => t.id === a.tipo_id)?.nombre ||
          '';
        const nameB =
          b.tipo?.nombre ||
          insumoTipo?.list?.data?.find((t) => t.id === b.tipo_id)?.nombre ||
          '';
        return nameA.localeCompare(nameB);
      },
      filterMultiple: true,
      filters:
        insumoTipo?.list?.data?.map((value) => ({
          text: value.nombre,
          value: value.id,
        })) || [],
    },
  ];
  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar
            </Button>
            <Button
              type="primary"
              icon={<SelectOutlined />}
              size="small"
              style={{ marginLeft: '3px' }}
              onClick={(e) => handleRestore()}
            >
              Recuperar
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <InsumoEditor
          id={rowEdit.id}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}

      {showRestore ? (
        <RestorePopup
          columns={restoreColumns}
          data={stateData.deleted.data}
          onCancel={handleRestoreCancel}
          onOk={handleRestoreOk}
          loading={
            stateData.deleted.status === callStatus.LIST_DELETED_IN_PROCESS
          }
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { insumo, proveedor, insumoTipo } = state;
  const stateData = insumo;
  return {
    stateData,
    proveedor,
    insumoTipo,
  };
};
export default connect(mapStateToProps)(withRouter(InsumoList));
